import React from "react";
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Skeleton,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";

interface CardProps {
  image: string;
  title: string;
  text: string;
  buttons: { text: string; route: string }[];
}

const buttonStyle = {
  fontSize: "12px",
  bottom: 0,
};

const HomepageCardWithButtons: React.FC<CardProps> = ({ image, title, text, buttons }) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        flex: 1,
        minWidth: 300,
        maxHeight: 300,
        minHeight: 300,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {image.length === 0 ? (
        <Skeleton sx={{ height: 170 }} animation={false} variant="rectangular" />
      ) : (
        <CardMedia component="img" height="170" image={image} alt="Bild" />
      )}
      <CardContent sx={{ flex: 1 }}>
        <Typography
          gutterBottom
          variant="subtitle2"
          component="div"
          color={theme.palette.primary.main}
        >
          {title}
        </Typography>
        <Typography variant="body1">{text}</Typography>
      </CardContent>

      <CardActions sx={{ justifyContent: "flex-start", alignItems: "flex-end" }}>
        {buttons.map((button) => (
          <Link key={button.route} to={button.route}>
            <Button key={button.text} size="small" color="secondary" sx={buttonStyle}>
              {button.text}
            </Button>
          </Link>
        ))}
      </CardActions>
    </Card>
  );
};

export default HomepageCardWithButtons;
